module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-rain-heavy-66285ec0.svg";